import client from '../client'

export async function makeOfferByBuyer({ offerAmount, buyNowListingId, acceptedPrices }) {
  return client(`${process.env.NEXT_PUBLIC_LISTINGS_DOMAIN}/api/DirectOffers/MakeOfferByBuyer`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify({ offerAmount, buyNowListingId, acceptedPrices }),
  })
}
